import React, {Component} from 'react';
import {connect} from 'react-redux';
import classNames from "classnames";
import FJToolbarCommon from '../view/FJToolbarCommon';
import FJToolbarDevider from '../view/FJToolbarDevider';
import FJFontFamilyContainer from '../view/FJFontFamilyContainer';
import FJColorContainer from '../view/FJColorContainer';
import FJToolbarIconButton from '../view/FJToolbarIconButton';
import FJTextResize from '../view/FJTextResize'
import FJAlign from '../view/FJAlign'
import FJPosition from "../view/FJPosition";
import {FJDocumentColorAction, FJToolbarAction} from "../../../redux/action/FJRoot.action";
import InlineSVG from "react-inlinesvg"
import FJFontBoldIcon from '../../../icon/FJFontBoldIcon.svg';
import FJFontItalicIcon from '../../../icon/FJFontItalicIcon.svg';
import FJWriteIcon  from '../../../icon/FJWriteIcon.svg';
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJLocalStore from "../../../store/FJLocalStore";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import {FJFontManager} from "fj-graph";

class FJToolbarTextContainer extends Component {

  _textZoomIn = () => {
    this.props.textZoom(FJCoreConstant.ZOOM_IN);
  };

  _textZoomOut = () => {
    this.props.textZoom(FJCoreConstant.ZOOM_OUT);
  };

  render(){
    const {
      fontBold,
      fontItalic,
      openTextEditPanel,
      fontFamily,
      textColor1,
      textColor2,
      bold,
      italic,
      disableBold,
      disableItalic,
      documentColors,
      addDocumentColor,
      deleteColor,
      textPositionChange,
      disabled,
      loadingFonts,
      alignment,
      alignmentChange,
      colorLength,
    } = this.props;
    let containerClass = classNames('c-toolbar-text', {active: this.props.active});
    let fontList = FJFontManager.fontItems();
    return (
      <FJToolbarCommon className={containerClass}>
        <FJFontFamilyContainer disabled={disabled} loadingFonts={loadingFonts} fontFamily={fontFamily} fontFamilyList={fontList} fontFamilyChange={(fontFamily) => {this.props.fontFamilyChanged(fontFamily)}} />
        <FJToolbarDevider />
        <FJColorContainer hasApplyToAll={false}
                          disabled={disabled}
                          useAnchorBody
                          isTopLayer
                          documentColors={documentColors}
                          addDocumentColor={addDocumentColor}
                          deleteColor={deleteColor}
                          isSolid={colorLength === 1}
                          colorData={{mainColor: textColor1, subColor: textColor2}}
                          colorDataChange={this.props.textColorChanged}
                          tips={FJLocalStore._('text-color')}
        />
        <FJToolbarDevider />
        <FJToolbarIconButton tooltip={FJLocalStore._('bold')} active={bold} disabled={disableBold || disabled}
                             className='u-tooltip-bottom' style={{float: 'left',marginRight: 6}}
                             onClick={fontBold} icon={<InlineSVG src={FJFontBoldIcon} element='div' />}/>
        <FJToolbarIconButton style={{marginRight: 0, float: 'left'}} tooltip={FJLocalStore._('italic')} active={italic} disabled={disableItalic || disabled} className='u-tooltip-bottom' onClick={fontItalic} icon={<InlineSVG src={FJFontItalicIcon} element='div' />}/>
        <FJToolbarDevider />
        <FJTextResize disabled={disabled} zoomIn={this._textZoomIn} zoomOut={this._textZoomOut}/>
        <FJAlign disabled={disabled} alignment={alignment} alignmentChanged={alignmentChange}/>
        <FJToolbarDevider />
        <FJPosition disabled={disabled} className='float-left' positionChange={textPositionChange}/>
        <FJToolbarIconButton style={{marginLeft: '6px'}} disabled={disabled} className='u-tooltip-bottom' tooltip={FJLocalStore._('edit-text')} onClick={openTextEditPanel} icon={<InlineSVG src={FJWriteIcon} element='div' />}/>
      </FJToolbarCommon>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loadingFonts: state.font.loadingFonts,
    documentColors: state.documentColor.documentColors,
    fontFamily: state.toolbar.fontFamily,
    disableBold: state.toolbar.disableBold,
    disableItalic: state.toolbar.disableItalic,
    textData: state.toolbarText.textData,
    textColor1: state.toolbarText.textColor1,
    textColor2: state.toolbarText.textColor2,
    alignment: state.toolbarText.alignment,
    bold: state.toolbarText.bold,
    italic: state.toolbarText.italic,
    colorLength: state.toolbarText.colorLength,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    alignmentChange: function(alignment) {
      dispatch(FJToolbarAction.setTextAnimationAlignmentAction(alignment));
    },
    textZoom: function (type) {
      dispatch(FJToolbarAction.setTextAnimationZoomAction(type));
    },
    fontBold: function () {
      FJCoreUtil.triggerBodyMousedown();
      dispatch(FJToolbarAction.setTextAnimationBoldAction());
    },
    fontItalic: function () {
      FJCoreUtil.triggerBodyMousedown();
      dispatch(FJToolbarAction.setTextAnimationItalicAction());
    },
    textPositionChange: function (index) {
      dispatch(FJToolbarAction.setTextAnimationPositionAction(index));
    },
    addDocumentColor: function (type, color) {
      dispatch(FJDocumentColorAction.addDocumentColorAction(type, color));
    },
    deleteColor: function (type, index) {
      dispatch(FJDocumentColorAction.deleteDocumentColorAction(type, index));
    },
    textColorChanged: function(type, colorData) {
      dispatch(FJToolbarAction.setTextAnimationColorAction(type, colorData));
    },
    fontFamilyChanged: function(fontFamily) {
      dispatch(FJToolbarAction.setTextAnimationFontFamilyAction(fontFamily));
    },
    openTextEditPanel: function () {
      dispatch(FJToolbarAction.showEditTextPanelAction());
    },
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FJToolbarTextContainer);
